import { FunctionComponent } from "react";

import { Stack } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { withPermissions } from "@components/withPermissions";
import { Permissions } from "@libs/permissions/permissions.enum";

import { AuditLogsFilter } from "./components/AuditLogsFilter";
import { AuditLogsList } from "./components/AuditLogsList";

export const AuditLogsBase: FunctionComponent = () => {
  return (
    <Stack tokens={{ childrenGap: 16 }} styles={{ root: { height: "100%" } }}>
      <SectionTitle>Audit Logs</SectionTitle>
      <AuditLogsFilter>
        {({ values }) => <AuditLogsList {...values} />}
      </AuditLogsFilter>
    </Stack>
  );
};

export const AuditLogs = withPermissions(
  AuditLogsBase,
  Permissions.PltCatalogUserRead
);
